import List from '@mui/material/List';
import PropTypes from 'prop-types';
import React from 'react';
import { useDefaultComponentValue } from '../../utils';
import SidebarSubheader from '../SidebarSubheader';
const COMPONENT_NAME = 'SidebarMenu';
const SidebarMenu = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, title, ...other } = props;
    return /*#__PURE__*/ React.createElement(List, {
        sx: {
            px: 2
        },
        ...other
    }, /*#__PURE__*/ React.createElement(SidebarSubheader, {
        hideResponsiveDivider: true
    }, title), children);
};
SidebarMenu.propTypes = {
    children: PropTypes.node,
    hideResponsiveDivider: PropTypes.bool,
    title: PropTypes.node
};
export default SidebarMenu;
